import { X } from 'lucide-react';
import Button from './Button';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    className?: string;
    size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}
export const Modal = ({ isOpen, onClose, title, children, className = '', size = 'lg' }: ModalProps) => {
    const sizeClasses = {
        sm: 'max-w-md',
        md: 'max-w-lg',
        lg: 'max-w-3xl',
        xl: 'max-w-5xl',
        '2xl': 'max-w-7xl',
    };

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-gray-600/50 overflow-y-auto h-full w-full z-50 px-4 py-6 sm:py-20">
                    <div className={`relative mx-auto p-0 w-full ${sizeClasses[size]} shadow-lg rounded-md bg-white`}>
                        {/* Header */}
                        <div className="flex items-center justify-between gap-3 p-4 sm:p-6 border-b border-gray-200">
                            <h3 className="min-w-0 break-words text-lg font-medium text-gray-900">
                                {title}
                            </h3>
                            <Button
                                onClick={onClose}
                                variant="ghost"
                                icon={<X size={24} />}
                            />
                        </div>
                        {/* Content */}
                        <div className={`p-4 ${className}`}>
                            {children}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};